<template>
  <div id="homemenu-tab-bar">
    <swiper class="homemenu-menu-swiper" :options="swiperOption">

        <swiper-slide class="homemenu-menu-menu-box">

          <router-link :to="{ name: 'events' }" class="homemenu-menu-wrapper" exact>
            <p>{{ $t('tabBar.events_attended') }}</p>
          </router-link>

          <router-link :to="{ name: 'incomingevents' }" class="homemenu-menu-wrapper">
            <p>{{ $t('tabBar.upcoming_events') }}</p>
          </router-link>

          <router-link :to="{ name: 'pastevents' }" class="homemenu-menu-wrapper">
            <p>{{ $t('tabBar.past_events') }}</p>
          </router-link>

        </swiper-slide>

    </swiper>
  </div>
</template>

<script>

export default {
  name: "OrganisationTabBar",

  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",  
      }
    };
  },
};
</script>

<style lang="less">
#homemenu-tab-bar {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;

  .homemenu-menu-swiper {
    width: 100%;
    margin-top: 15px;
    border-bottom: 1px solid #F1F3F6;

    .homemenu-menu-menu-box {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .homemenu-menu-wrapper {
        margin: 16px 18px;

        &:hover {
          text-decoration: none;
        }

        &.router-link-active {
          position: relative;

          p {
            color: #292F3B !important;
            font-weight: 500;
            text-align: center;
          }

          &:before {
            content: '';
            width: calc(~"100% + 20px");
            height: 2px;
            background-color: #03658C;
            display: block;
            margin-top: 32px;
            margin-left: -10px;
            position: absolute;
          }
        }

        p {
          color: #8C929C;
          font-size: 16px;
          font-weight: 500;
          margin: 0px;
          padding: 0px;
          line-height: 18px;
          text-align: center;
        }
      }
    }
  }
}

@media (max-width: 560px) {
  #homemenu-tab-bar {

    .homemenu-menu-swiper {

      .homemenu-menu-menu-box {
        
        .homemenu-menu-wrapper {

          &.router-link-active {

            &:before {
              margin-top: 50px;
            }
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/HomeMenu.vue